import { render, staticRenderFns } from "./success-page-layout.vue?vue&type=template&id=436aec20&"
import script from "./success-page-layout.vue?vue&type=script&lang=js&"
export * from "./success-page-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports